module.exports = __webpack_public_path__ + "site/img/background.02727fd1.svg";